import { render, staticRenderFns } from "./previewVideo.vue?vue&type=template&id=c2ae8058&scoped=true&"
import script from "./previewVideo.vue?vue&type=script&lang=js&"
export * from "./previewVideo.vue?vue&type=script&lang=js&"
import style0 from "./previewVideo.vue?vue&type=style&index=0&id=c2ae8058&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae8058",
  null
  
)

export default component.exports